import React from 'react'

const AdminDashboard = function() {

    return (
        <div className="admin-dashboard">
            <h2>Dashboard</h2>
        </div>
    )

}

export default AdminDashboard
